import React, { useState } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';


export default function Contactus() {
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [phone, setPhone] = useState();
    const [message, setMessage] = useState();



    const handleFormSubmit = async () => {
        const url = 'http://www.speedtypes.com/laravel/public/api/contact-us';
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: name,
                    email: email,
                    phone: phone,
                    message: message,

                }),
            });

            if (response.ok) {
                const data = await response.json();
                console.log(data);
                if (data.status) {
                    setName('')
                    setEmail('')
                    setPhone('')
                    setMessage('')
                }
            } else {
                console.error('Error:', response.statusText);
            }
        } catch (error) {
            console.error('Error:', error);
        }

    };


    const handleNameChange = (event) => {
        const inputValue = event.target.value;
        // Validate input to allow only alphabetic characters and spaces
        if (/^[a-zA-Z\s]*$/.test(inputValue)) {
            setName(inputValue);
        }
    };


    const contactMethods = [
        {
            icon:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-gray-600">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
            ,
            contact: "info@speedtypes.com"
        },
        {
            icon:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-gray-600">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                </svg>
            ,
            contact: "+971 56 265 7300"
        },
        {
            icon:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-gray-600">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>

            ,
            // contact: "Opal Tower, Business Bay, Office Number 104, Dubai, UAE"
            contact: "Opal Tower, Business Bay Offic No. 104, Dubai, UAE"
        },
    ]

    return (
        <>
            <div className='contact-bg-img' id='contactus'>
                <section className="py-28">
                    <div className="max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
                        <div className="max-w-xxl space-y-3 md:mx-auto mb-5">
                            <p className="text-white text-3xl font-bold sm:text-4xl">
                                Talk to Our Business <span style={{ color: "#eab308" }}>Setup Advisors </span>
                            </p>
                        </div>
                        <div className="max-w-xl space-y-3 md:mx-auto">
                            <p className="text-white">
                                We know that there are hefty processes you want to avoid. Don’t worry! We’re here to give you and your venture a promising head start.
                            </p>
                        </div>
                        <div className="mt-4">
                            <a href="/" className="inline-block py-2 px-4 text-white font-medium bg-gray-800 duration-150 hover:bg-gray-700 active:bg-gray-900 rounded-lg shadow-md hover:shadow-none">
                                Get started
                            </a>
                        </div>
                    </div>
                </section>
            </div>
            <main className="py-14">
                <div className="max-w-screen-xl mx-auto px-4 text-gray-600 md:px-8">
                    <div className="max-w-md mx-auto gap-12 justify-around lg:flex lg:max-w-none">
                        <div className="max-w-lg space-y-3">
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className="text-gray-800 text-3xl font-bold sm:text-5xl mb-5" style={{ marginBottom: 40 }}>
                                    Get in <span style={{ color: "#eab308" }}>Touch</span>
                                </h3>
                                <p className='text-gray-600 mb-5'>
                                    Simply fill out the form below and tell us as a first step what kind of business you are planning to have and we will get in touch with you as soon as possible.
                                </p>
                            </ScrollAnimation>
                            <div>
                                <ul className="mt-6 flex flex-wrap gap-x-10 gap-y-6 items-center">
                                    {
                                        contactMethods.map((item, idx) => (
                                            <li key={idx} className="flex items-center gap-x-3">
                                                <div className="flex-none text-gray-400">
                                                    {item.icon}
                                                </div>
                                                <p className='text-gray-600 text-1xl font-semibold sm:text-1xl'>{item.contact}</p>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                        <div class="flex items-center min-h-screen dark:bg-gray-900" style={{ width: "100%", marginTop: -50 }}>
                            <div class="container mx-auto">
                                <div class="max-w-lg mx-auto my-10 bg-white p-5 rounded-md shadow-lg">
                                    <div class="m-7">
                                        <form method="POST" >
                                            <input type="checkbox" name="botcheck" id="" style={{ display: 'none' }} />
                                            <div class="mb-6">
                                                <label for="name" class="block mb-2 font-medium text-sm text-gray-500 dark:text-gray-400">Full Name</label>
                                                <input
                                                    type="text"
                                                    value={name}
                                                    onChange={handleNameChange}
                                                    placeholder="John Doe"
                                                    className="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-500 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500"
                                                />
                                            </div>
                                            <div class="mb-6">
                                                <label for="email" class="block mb-2 font-medium text-sm text-gray-500 dark:text-gray-400">Email Address</label>
                                                <input type="email" name="email" id="email" value={email} onChange={event => setEmail(event.target.value)} placeholder="you@gmail.com" required class="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-500 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" />
                                            </div>
                                            <div class="mb-6">
                                                <label for="phone" class="text-sm mb-2 font-medium text-gray-500 dark:text-gray-400">Phone Number</label>
                                                <input type="text" name="phone" value={phone} onChange={event => setPhone(event.target.value)} id="phone" placeholder="+1 (555) 1234-567" required class="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-500 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" />
                                            </div>
                                            <div class="mb-6">
                                                <label for="message" class="block mb-2 font-medium text-sm text-gray-500 dark:text-gray-400">How can we help? </label>
                                                <textarea rows="5" name="message" value={message} onChange={event => setMessage(event.target.value)} id="message" placeholder="Your Message" class="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-500 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" required></textarea>
                                            </div>
                                            <div class="mb-6">
                                                <button type="button" onClick={handleFormSubmit} class="w-full px-3 py-4 text-white bg-yellow-500 rounded-md focus:bg-yellow-700 focus:outline-none">
                                                    Send Now
                                                </button>
                                            </div>
                                            <p class="text-base text-center text-gray-400" id="result"></p>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>


            <div className=''>
                <section className="py-6">
                    <div className="max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
                        <div className="map-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.398210865007!2d55.2659960836172!3d25.18979007564745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6900423b3629%3A0x3d57214d3192424c!2sOPAL%20TOWER%2C%20BUSINESS%20BAY!5e0!3m2!1sen!2s!4v1713875028453!5m2!1sen!2s"
                                width="600"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Google Map"
                                className="map-frame"
                            ></iframe>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}
